import React from "react";
import { useParams, useHistory } from "react-router-dom";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Breadcrumb from "sushiweb/Breadcrumb";
import Back from "sushiweb/Icons/all/Back";
import Table from "../../components/Common/Table";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import variables from "../../constants/assets/variables";
import * as UserActions from "../../store/actions/User";
import * as SubIssueTypeActions from "../../store/actions/SubIssueTypes";
import Button from "sushiweb/Button";
import Permission from "../../components/Common/Permission";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";

const SubIssueTips = (props) => {
  const { setSideBarCollapsed, setStatus, getSubIssueTypesDetails } = props;
  const history = useHistory();
  const { id } = useParams();
  const subIssueTypeId = id;

  const [isLoading, setIsLoading] = React.useState(true);
  const [subIssueType, setSubIssueType] = React.useState({});
  const [tipsMappings, setTipsMappings] = React.useState([]);

  const tableFields = [
    { key: "id", heading: "ID" },
    { key: "name", heading: "Name" },
    { key: "description", heading: "Description" },
    { key: "ctaName", heading: "CTA Name" },
    { key: "actionType", heading: "Action Type" },
    { key: "headingText", heading: "Heading" },
    { key: "disQualifierContent", heading: "Dis Qualifier Content" },
    { key: "connotation", heading: "Connotation" },
    { key: "collectRating", heading: "Collect Rating" },
    { key: "enabled", heading: "Enabled" },
    { key: "raiseTicketEnabled", heading: "Raise Ticket Enabled" },
    { key: "rank", heading: "Rank" },
    { key: "actions", heading: "Actions" },
  ];

  const getFieldValue = (tip, key) => {
    if (key === "actions") {
      return (
        <span
          onClick={() =>
            history.push(
              `/sub-issue-types/${subIssueTypeId}/tips/${tip.id}/view`,
              { tipData: tip }
            )
          }
          className="edit-options cursor-pointer sushi-btn"
        >
          View/Edit
        </span>
      );
    }
    if (
      key === "enabled" ||
      key === "collectRating" ||
      key === "raiseTicketEnabled"
    ) {
      return tip[key] ? "Yes" : "No";
    }
    return tip[key] !== undefined ? tip[key].toString() : "-";
  };

  React.useEffect(() => {
    setSideBarCollapsed(true);

    if (subIssueTypeId) {
      setIsLoading(true);
      getSubIssueTypesDetails(subIssueTypeId)
        .then((response) => {
          setSubIssueType(response?.data || {});
          setTipsMappings(response?.data?.tipsMappings || []);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching Sub Issue Tips:", error);
          setIsLoading(false);
        });
    }
  }, [subIssueTypeId, setSideBarCollapsed, setStatus, getSubIssueTypesDetails]);

  const handleBackClick = () => {
    history.push('/sub-issue-types');
  };

  return (
    <SubIssueTipsContainer>
      <FlexContainer>
        <LeftContainer justify="flex-start">
          <Back
            onClick={handleBackClick}
            className="mr-10 backBtn"
            color={variables.grey400}
          />
          <Breadcrumb className="sushi-breadcrumbs">
            <Breadcrumb.Link onClick={handleBackClick}>
              Sub Issue Types
            </Breadcrumb.Link>
            <Breadcrumb.Link>
              {subIssueType.name || subIssueTypeId}
            </Breadcrumb.Link>
          </Breadcrumb>
        </LeftContainer>
        <RightContainer flexpct="25">
          <Permission
            requiredPerms={[
              MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DASHBOARD]
                .CREATE_SUB_ISSUE_TYPE,
            ]}
          >
            <Button
              data-testid="addTipBtn"
              onClick={() =>
                history.push(`/sub-issue-types/${subIssueTypeId}/tips/create`)
              }
              className="sushi-btn"
              appearance="primary"
            >
              Add Tip
            </Button>
          </Permission>
        </RightContainer>
      </FlexContainer>

      <FlexContainer align="flex-start" className="mt-20">
        <Heading>Sub Issue Tips</Heading>
      </FlexContainer>

      {isLoading ? (
        <div>Loading tips...</div>
      ) : (
        <TableContainer>
          {tipsMappings.length > 0 ? (
            <Table
              list={tipsMappings}
              getFieldValue={getFieldValue}
              fields={tableFields}
            />
          ) : (
            <div className="no-tips">
              No tips found for this sub issue type.
            </div>
          )}
        </TableContainer>
      )}
    </SubIssueTipsContainer>
  );
};

const RightContainer = styled(FlexContainer)`
  flex: ${({ flexpct }) => (flexpct ? `0 1 ${flexpct}%` : "0 1 35%")};
  justify-content: flex-end;
`;

const SubIssueTipsContainer = styled.div``;

const LeftContainer = styled(FlexContainer)`
  flex: 0 1 30%;
  margin-bottom: 20px;
  & > div {
    flex-direction: row;
  }
`;

const TableContainer = styled.div`
  margin-top: 20px;
  height: calc(100vh - 215px);

  .no-tips {
    text-align: center;
    padding: 20px;
    font-size: 16px;
    color: ${variables.grey400};
  }
`;

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    setSideBarCollapsed: bindActionCreators(
      UserActions.setSideBarCollapsed,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getSubIssueTypesDetails: bindActionCreators(
      SubIssueTypeActions.getSubIssueTypesDetails,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubIssueTips);
